@for (error of controlErrors(); track error.id) {
  <div>{{ error.message }}</div>
}
<ng-content/>
